import { Injectable } from '@angular/core';

import { BaseHttpService } from 'shared/base/_base-http.service';
import { Observable } from 'rxjs';
import { Config } from '../config/env.config';
import {of} from 'rxjs/internal/observable/of';
import {delay} from 'rxjs/operators';


@Injectable()
export class InterchangeService extends BaseHttpService {

  getInterchangeList(brandId: any, status: string): Observable<any> {
    return of([
      {
        title: 'None (coming soon)',
        option: 'none',
      },
      {
        title: 'Premium (coming soon)',
        option: 'premium',
      },
      {
        title: 'OEM (coming soon)',
        option: 'oem',
      },
      {
        title: 'Standard (coming soon)',
        option: 'standard',
      },
    ]).pipe(delay(1000));
    // return this.http.get(`${Config.API}/interchange/${brandId}/${status}`)
    //   .catch(this.handleError.bind(this));
  }
}
